export const SCORE_URL = '/api/v1/backend/score';

export const EVENTS_CONFIG_BY_ENV: Record<string, { trackingReceiverUrl: string; writeKey: string; goyaUrl: string; sentryDsn: string; kfpPath: string; keventsUrl: string }> = {
  dev: {
    trackingReceiverUrl: 'https://int.dev.gid.team',
    writeKey: 'web_sso:t:e7d752e6-e45f-4db6-8c0c-a6f1ae4997e8',
    goyaUrl: 'https://goevents-dev.gid-auth.ru',
    sentryDsn: 'https://697716126da3d86ce62413de755411f5@sentry.gid.team/248',
    kfpPath: '/kfp/preprod/das.obf.js',
    keventsUrl: 'https://dev-auth.k8s-dev.gid.team',
  },
  test: {
    trackingReceiverUrl: 'https://int.dev.gid.team',
    writeKey: 'web_sso:t:e7d752e6-e45f-4db6-8c0c-a6f1ae4997e8',
    goyaUrl: 'https://goevents-test.gid-auth.ru',
    sentryDsn: 'https://697716126da3d86ce62413de755411f5@sentry.gid.team/248',
    kfpPath: '/kfp/preprod/das.obf.js',
    keventsUrl: 'https://test-auth.k8s-dev.gid.team',
  },
  stage: {
    trackingReceiverUrl: 'https://int.dev.gid.team',
    writeKey: 'web_sso:t:e7d752e6-e45f-4db6-8c0c-a6f1ae4997e8',
    goyaUrl: 'https://goevents-stage.k8s-dev.gid.team',
    sentryDsn: 'https://697716126da3d86ce62413de755411f5@sentry.gid.team/248',
    kfpPath: '/kfp/preprod/das.obf.js',
    keventsUrl: 'https://kevents-stage.gid-auth.ru',
  },
};
